export default {"src":"/_next/static/media/tiktok.d009f7d9.svg","height":20,"width":17,"blurWidth":0,"blurHeight":0};